import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Row, Col } from 'react-bootstrap';

const LoadingComponent = () => (
  <>
    <Row className="align-items-center" md={2} xs={1}>
      <Skeleton height={250} width={550}></Skeleton>
      <Skeleton height={250} width={550}></Skeleton>
    </Row>
    <Col className='ml-0 pl-0 mt-5'>
      <Col md={4} className='ml-0 pl-0'>
        <Skeleton className='ml-0 pl-0 mt-3' width="55%" height="2em"></Skeleton>
        <Skeleton className='ml-0 pl-0' height="1.5em" />
      </Col>
      <Row md={4}>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
      </Row>
    </Col>
    <Col className='ml-0 pl-0 mt-5'>
      <Col md={4} className='ml-0 pl-0'>
        <Skeleton className='ml-0 pl-0 mt-3' width="55%" height="2em"></Skeleton>
        <Skeleton className='ml-0 pl-0' height="1.5em" />
      </Col>
      <Row md={4}>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
        <div className='d-flex flex-column'>
          <Skeleton height={160} width={260} />
          <div className='d-flex'>
            <Skeleton width={40} height={40} className='mr-1' circle/>
            <div className='d-flex flex-column'>
              <Skeleton width={155} />
              <Skeleton width={50} />
              <Skeleton count={3} width={215} className='d-block mb-1'/>
            </div>
          </div>
        </div>
      </Row>
    </Col>
  </>
)

export default LoadingComponent;
